<div class="container" *ngIf="showForm">
    <mat-card class="card-container">
        <mat-card-content>
            <form enctype="multipart/form-data" [formGroup]="srecForm" (ngSubmit)="onSubmit($event)">
                <div class="fields">
                    <div *ngIf="isCommercial" formGroupName="ciInfo">
                        <p>C&I Customer Information</p>
                        <div class="ci-row">
                            <mat-form-field>
                                <mat-label>Customer Type</mat-label>
                                <mat-select id="customerType" formControlName="customerType">
                                    <mat-option value="existingPartner">Existing Spruce C&I Installation
                                        Partner</mat-option>
                                    <mat-option value="existingResidentialPartner">Existing Spruce Installation
                                        Partner</mat-option>
                                    <mat-option value="businessOwner">Business owner with solar array</mat-option>
                                    <mat-option value="installer">Solar installer registering on behalf of
                                        customer</mat-option>
                                </mat-select>
                                <mat-error *ngIf="
                                        srecForm.get('ciInfo.customerType')?.invalid &&
                                        srecForm.get('ciInfo.customerType')?.touched
                                    ">
                                    Customer Type is required
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Conditional fields based on customer type -->
                        <div class="ci-row"
                            *ngIf="srecForm.get('ciInfo.customerType')?.value === 'existingPartner' || srecForm.get('ciInfo.customerType')?.value === 'existingResidentialPartner'">
                            <mat-form-field>
                                <mat-label>Partner Company Name</mat-label>
                                <input matInput id="partnerCompanyName" formControlName="partnerCompanyName" />
                                <mat-error *ngIf="
                                        srecForm.get('ciInfo.partnerCompanyName')?.invalid &&
                                        srecForm.get('ciInfo.partnerCompanyName')?.touched
                                    ">
                                    Partner Company Name is required
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="ci-row" *ngIf="srecForm.get('ciInfo.customerType')?.value === 'installer'">
                            <mat-form-field>
                                <mat-label>Site Owner Company Name</mat-label>
                                <input matInput id="siteOwnerCompany" formControlName="siteOwnerCompany" />
                                <mat-error *ngIf="
                                        srecForm.get('ciInfo.siteOwnerCompany')?.invalid &&
                                        srecForm.get('ciInfo.siteOwnerCompany')?.touched
                                    ">
                                    Site Owner Company Name is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-label>Form Submitter Name</mat-label>
                                <input matInput id="formSubmitterName" formControlName="formSubmitterName" />
                                <mat-error *ngIf="
                                        srecForm.get('ciInfo.formSubmitterName')?.invalid &&
                                        srecForm.get('ciInfo.formSubmitterName')?.touched
                                    ">
                                    Form Submitter Name is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div formGroupName="contactInfo">
                        <p>Contact Information</p>
                        <div class="first-row">
                            <!-- First Name -->
                            <mat-form-field>
                                <mat-label>First Name</mat-label>
                                <input matInput id="firstName" formControlName="firstName" />
                                <mat-error *ngIf="
                                        srecForm.get('contactInfo.firstName')?.invalid &&
                                        srecForm.get('contactInfo.firstName')?.touched
                                    ">
                                    First Name is required
                                </mat-error>
                            </mat-form-field>

                            <!-- Last Name -->
                            <mat-form-field appearance="fill">
                                <mat-label>Last Name</mat-label>
                                <input matInput id="lastName" formControlName="lastName" />
                                <mat-error *ngIf="
                                        srecForm.get('contactInfo.lastName')?.invalid &&
                                        srecForm.get('contactInfo.lastName')?.touched
                                    ">
                                    Last Name is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>Phone Number</mat-label>
                                <input maxlength="15" matInput id="phoneNumber" formControlName="phoneNumber"
                                    mask="(000) 000-0000" />
                                <mat-error *ngIf="
                                        srecForm.get('contactInfo.phoneNumber')?.invalid &&
                                        srecForm.get('contactInfo.phoneNumber')?.touched
                                    ">
                                    Phone Number is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>Phone Type</mat-label>
                                <mat-select id="phoneNumberType" formControlName="phoneNumberType">
                                    <mat-option value="Mobile">Mobile - iOS</mat-option>
                                    <mat-option value="Mobile">Mobile - Other</mat-option>
                                    <mat-option value="Home">Home</mat-option>
                                    <mat-option value="Work">Work</mat-option>
                                </mat-select>
                                <mat-error *ngIf="
                                        srecForm.get('contactInfo.phoneNumberType')
                                            ?.invalid &&
                                        srecForm.get('contactInfo.phoneNumberType')?.touched
                                    ">
                                    Phone Type is required
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="second-row">
                            <mat-form-field appearance="fill">
                                <mat-label>Street Address</mat-label>
                                <input matInput id="streetAddress" formControlName="streetAddress" />
                                <mat-error *ngIf="
                                        srecForm.get('contactInfo.streetAddress')
                                            ?.invalid &&
                                        srecForm.get('contactInfo.streetAddress')
                                            ?.touched
                                    ">
                                    Street Address is required
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Address Group -->
                        <div class="third-row">
                            <mat-form-field appearance="fill">
                                <mat-label>City</mat-label>
                                <input matInput id="city" formControlName="city" />
                                <mat-error *ngIf="
                                        srecForm.get('contactInfo.city')?.invalid &&
                                        srecForm.get('contactInfo.city')?.touched
                                    ">
                                    City is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>State</mat-label>
                                <input matInput id="state" formControlName="state" />
                                <mat-error *ngIf="
                                        srecForm.get('contactInfo.state')
                                            ?.invalid &&
                                        srecForm.get('contactInfo.state')?.touched
                                    ">
                                    State is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>Zip Code</mat-label>
                                <input matInput id="zipCode" formControlName="zipCode" maxlength="5" mask="00000" />

                                <mat-error *ngIf="
                                        srecForm.get('contactInfo.zipCode')
                                            ?.invalid &&
                                        srecForm.get('contactInfo.zipCode')?.touched
                                    ">
                                    Valid Zip Code is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>Country</mat-label>
                                <input matInput id="country" formControlName="country" />
                            </mat-form-field>
                        </div>
                        <div class="fourth-row">
                            <!-- Email Address -->
                            <mat-form-field class="email" appearance="fill">
                                <mat-label>Email</mat-label>
                                <input matInput id="emailAddress" formControlName="emailAddress" type="email" />
                                <mat-error *ngIf="
                                        srecForm.get('contactInfo.emailAddress')?.invalid &&
                                        srecForm.get('contactInfo.emailAddress')?.touched
                                    ">
                                    Valid Email is required
                                </mat-error>
                            </mat-form-field>

                            <mat-checkbox [checked]="true" class="system-owner" [disabled]="true">
                                Are you the system owner?
                            </mat-checkbox>
                        </div>
                    </div>

                    <div formGroupName="serviceInfo">
                        <div class="service-info-header">
                            <p>Service Information</p>
                            <mat-checkbox class="service-address-checkbox" formControlName="isServiceSame"
                                (change)="onServiceCheckboxChange($event)">
                                Is service address same as above?
                            </mat-checkbox>
                        </div>
                        <div class="fifth-row">
                            <mat-form-field appearance="fill">
                                <mat-label>Service Street Address</mat-label>
                                <input matInput id="serviceStreetAddress" formControlName="serviceStreetAddress" />
                            </mat-form-field>
                        </div>

                        <div class="sixth-row">
                            <mat-form-field appearance="fill">
                                <mat-label>Service City</mat-label>
                                <input matInput id="serviceCity" formControlName="serviceCity" />
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>Service State</mat-label>
                                <input matInput id="serviceState" formControlName="serviceState" />
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>Service Zip Code</mat-label>
                                <input matInput id="serviceZipCode" formControlName="serviceZipCode" maxlength="5"
                                    mask="00000" />
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>Service Country</mat-label>
                                <input matInput id="serviceCountry" formControlName="serviceCountry" />
                            </mat-form-field>
                        </div>
                        <div class="seventh-row">
                            <mat-form-field class="item" appearance="fill">
                                <mat-label>Utility</mat-label>
                                <input type="text" matInput [formControl]="utilityFormControl" [matAutocomplete]="auto"
                                    placeholder="Select or type utility name" />
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFilteredUtilities">
                                    @for (option of filteredUtilities | async; track option) {
                                    <mat-option [value]="option">{{
                                        option.utilityName
                                        }}</mat-option>
                                    }
                                    <mat-option value="other">Other</mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="
                                        srecForm.get('serviceInfo.utility')?.invalid &&
                                        srecForm.get('serviceInfo.utility')?.touched
                                    ">
                                    Utility is required.
                                </mat-error>
                            </mat-form-field>

                            <!-- Referral Source -->
                            <mat-form-field class="item" appearance="fill">
                                <mat-label>Referral Source</mat-label>
                                <input matInput [placeholder]="
                                        srecForm.get('referralSource')?.value ||
                                        ''
                                    " [value]="referralSource" id="referralSource" formControlName="referralSource" />
                            </mat-form-field>
                        </div>

                        <!-- C&I Specific Fields -->
                        <div class="eighth-row" *ngIf="isCommercial">
                            <mat-form-field class="item" appearance="fill">
                                <mat-label>PTO Date</mat-label>
                                <input matInput [matDatepicker]="ptoPicker" id="ptoDate" formControlName="ptoDate" />
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matIconSuffix [for]="ptoPicker"></mat-datepicker-toggle>
                                <mat-datepicker #ptoPicker></mat-datepicker>
                                <mat-error *ngIf="
                                        srecForm.get('serviceInfo.ptoDate')?.invalid &&
                                        srecForm.get('serviceInfo.ptoDate')?.touched
                                    ">
                                    Please enter a valid date
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="item" appearance="fill">
                                <mat-label>AC Capacity (kW)</mat-label>
                                <input matInput type="number" step="0.1" min="0" id="acCapacity"
                                    formControlName="acCapacity" />
                                <mat-error *ngIf="
                                        srecForm.get('serviceInfo.acCapacity')?.invalid &&
                                        srecForm.get('serviceInfo.acCapacity')?.touched
                                    ">
                                    AC Capacity must be a positive number
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="item" appearance="fill">
                                <mat-label>DC Capacity (kW)</mat-label>
                                <input matInput type="number" step="0.1" min="0" id="dcCapacity"
                                    formControlName="dcCapacity" />
                                <mat-error *ngIf="
                                        srecForm.get('serviceInfo.dcCapacity')?.invalid &&
                                        srecForm.get('serviceInfo.dcCapacity')?.touched
                                    ">
                                    DC Capacity must be a positive number
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div formGroupName="meterInfo" class="meter-info-section">
                        <div class="subheader-container">
                            <p>Meter Information</p>
                            <mat-icon class="help-icon" fontIcon="help"
                                mtxTooltip="Input information related to your system meter."
                                [mtxTooltipPosition]="position">
                            </mat-icon>
                            <mat-icon class="meter-image" fontIcon="image" [mtxTooltip]="meterImageTooltip"
                                [mtxTooltipPosition]="position">
                            </mat-icon>
                        </div>
                        <div class="eighth-row">
                            <mat-form-field class="item" appearance="fill">
                                <mat-label>Meter Manufacturer</mat-label>
                                <input type="text" matInput id="meterManufacturer"
                                    [formControl]="meterManufacturerFormControl" [matAutocomplete]="autoMeterMan" />
                                <mat-autocomplete #autoMeterMan="matAutocomplete" [displayWith]="
                                        displayFilteredMeterManufacturers
                                    ">
                                    @for (
                                    option of filteredMeterManufacturers
                                    | async;
                                    track option
                                    ) {
                                    <mat-option [matTooltip]="option.value" matTooltipShowDelay="1000"
                                        [value]="option">{{ option.value }}</mat-option>
                                    }
                                    <mat-option value="other">Other</mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="
                                        srecForm.get(
                                            'meterInfo.meterManufacturer'
                                        )?.invalid &&
                                        srecForm.get(
                                            'meterInfo.meterManufacturer'
                                        )?.touched
                                    ">
                                    Meter Manufacturer
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="item" appearance="fill">
                                <mat-label>Meter Model</mat-label>
                                <input type="text" matInput id="meterModel" [formControl]="meterModelFormControl"
                                    [matAutocomplete]="autoMeterMod" />
                                <mat-autocomplete #autoMeterMod="matAutocomplete">
                                    @for (option of filteredMeterModels | async; track option) {
                                    <mat-option [matTooltip]="option" matTooltipShowDelay="1000" [value]="option">{{
                                        option }}</mat-option>
                                    }
                                    <mat-option value="other">Other</mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="
                                        srecForm.get('meterInfo.meterModel')
                                            ?.invalid &&
                                        srecForm.get('meterInfo.meterModel')
                                            ?.touched
                                    ">
                                    Meter Model
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="ninth-row">
                            <!-- Meter Serial Number -->
                            <mat-form-field class="item" appearance="fill">
                                <mat-label>Meter Serial Number</mat-label>
                                <input matInput id="meterSerialNumber" formControlName="meterSerialNumber" />
                            </mat-form-field>

                            <!-- Node Id -->
                            <mat-form-field class="item" appearance="fill">
                                <mat-label>Node Id</mat-label>
                                <input matInput id="nodeId" formControlName="nodeId"
                                    matTooltip="Node IDs for a majority of meter makes and models correspond to the serial number located on the face of meter. Please see example of meter picture for sample Node ID."
                                    matTooltipPosition="above" matTooltipClass="custom-tooltip" />
                            </mat-form-field>

                            <!-- Monitoring Service -->
                            <mat-form-field class="item" appearance="fill">
                                <mat-label>Monitoring Service</mat-label>
                                <input type="text" matInput [formControl]="monitoringServiceFormControl"
                                    [matAutocomplete]="autoMonitoring" placeholder="Select monitoring service" />
                                <mat-autocomplete #autoMonitoring="matAutocomplete"
                                    [displayWith]="displayFilteredMonitoringServices">
                                    @for (option of filteredMonitoringServices | async; track option) {
                                    <mat-option [value]="option">{{
                                        option.serviceName
                                        }}</mat-option>
                                    }
                                    <mat-option value="other">Other</mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="
                                        srecForm.get('meterInfo.monitoringService')?.invalid &&
                                        srecForm.get('meterInfo.monitoringService')?.touched
                                    ">
                                    Monitoring Service is required.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <mat-accordion class="supporting-doc-header">
                        <mat-expansion-panel class="mat-elevation-z0" expanded="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <p>Supporting Documentation</p>
                                </mat-panel-title>
                                <mat-panel-description class="mat-elevation-z0">
                                    <mat-icon class="help-icon" fontIcon="help"
                                        mtxTooltip="Click here for more information on supporting documents required for upload."
                                        [mtxTooltipPosition]="position">
                                    </mat-icon>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <span>Please upload one or more of the supporting documents as described below. If you do
                                not have all documentation, please
                                Submit application and Spruce will follow up via email to source the remaining required
                                documentation.</span>
                            <mat-table [dataSource]="dataSource" class="mat-elevation-z1">
                                <!-- Form Type Column -->
                                <ng-container matColumnDef="formType">
                                    <mat-header-cell *matHeaderCellDef>
                                        Tag Type
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let info">
                                        {{ info.formType }}
                                    </mat-cell>
                                </ng-container>

                                <!-- Description Column -->
                                <ng-container matColumnDef="description">
                                    <mat-header-cell *matHeaderCellDef>
                                        Description
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let info">
                                        {{ info.description }}
                                    </mat-cell>
                                </ng-container>

                                <!-- Example Image Column -->
                                <ng-container matColumnDef="exampleImage">
                                    <mat-header-cell *matHeaderCellDef>
                                        Example
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let info">
                                        <mat-icon fontIcon="image" [mtxTooltip]="tooltipTpl"
                                            [mtxTooltipPosition]="position" [mtxTooltipContext]="{
                                                    exampleImage:
                                                        info.exampleImage,
                                                }" mtxTooltipClass="context-help-tooltip"></mat-icon>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                <mat-row *matRowDef="
                                        let row;
                                        columns: displayedColumns
                                    "></mat-row>
                            </mat-table>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <div class="upload-container">
                        <input type="file" class="file-input" accept=".jpg,.png,.pdf,.txt,.svg,.doc,.docx"
                            formControlName="uploadFiles" (change)="onFileChange($event)" #fileUpload multiple />
                        {{
                        files.length > 0
                        ? files.length + ' files uploaded.'
                        : 'No files uploaded yet'
                        }}
                        <button mat-icon-button type="button" class="upload-btn" (click)="fileUpload.click()">
                            <mat-icon>attach_file</mat-icon>
                        </button>
                    </div>

                    <table *ngIf="supportingFiles.length > 0">
                        <thead>
                            <tr>
                                <th class="file-name-col-header-cell">
                                    File Name
                                </th>
                                <th class="tag-type-col-header-cell">
                                    Tag Type
                                </th>
                                <th class="action-col-header-cell">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="
                                    let file of supportingFiles;
                                    let i = index
                                ">
                                <td class="file-name-col-cell">
                                    {{ file.fileName }}
                                </td>
                                <td class="tag-type-col-cell">
                                    <mat-select [formControl]="
                                            $any(
                                                supportingFileForm.controls[
                                                    'tagType' + i
                                                ]
                                            )
                                        " (selectionChange)="
                                            onTagTypeChange($event, i)
                                        ">
                                        <mat-option *ngFor="let type of tagTypes" [value]="type">{{ type }}</mat-option>
                                    </mat-select>
                                </td>
                                <td>
                                    <button (click)="deleteFile(i)" mat-icon-button class="delete-btn" type="button"
                                        matTooltip="Delete this file." matTooltipShowDelay="1000">
                                        <mat-icon fontIcon="delete"></mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="addtl-info-container">
                    <div class="subheader-container">
                        <p class="addtl-info-header">
                            Additional Information
                        </p>
                        <mat-icon class="help-icon" fontIcon="help"
                            mtxTooltip="Additional information you may wish to share." [mtxTooltipPosition]="position">
                        </mat-icon>
                    </div>

                    <mat-form-field class="item">
                        <mat-label>Please input any additional comments/details
                            here.</mat-label>
                        <textarea matInput id="addtlComment" formControlName="addtlComment"></textarea>
                    </mat-form-field>
                </div>

                <div class="tos-container" *ngIf="!isCommercial">
                    <div>
                        <span>I have read and agree to the
                            <button (click)="onTOSClick()" class="tos-button" type="button">
                                terms
                            </button>
                            .*</span>
                    </div>
                    <mat-checkbox id="tosCheckbox" formControlName="tosCheckbox">
                    </mat-checkbox>
                    <mat-error *ngIf="
                            srecForm.get('tosCheckbox')?.invalid &&
                            srecForm.get('tosCheckbox')?.touched
                        ">
                        You must agree to the terms in order to submit this
                        form.
                    </mat-error>
                </div>

                <button mat-raised-button color="primary" class="submit-form-button" type="submit" [disabled]="
                        srecForm.invalid ||
                        isSubmitLoading ||
                        (!isCommercial && !srecForm.get('tosCheckbox')?.value)
                    ">
                    <mat-spinner *ngIf="isSubmitLoading" diameter="20"></mat-spinner>
                    <span *ngIf="!isSubmitLoading">Submit</span>
                </button>

                <mat-error *ngIf="isSubmitFailure" class="submit-error">
                    Something went wrong. Please try again.
                </mat-error>
            </form>
        </mat-card-content>
    </mat-card>
</div>

<ng-template #tooltipTpl let-data>
    <img [src]="data.exampleImage" style="max-width: 500px; display: block;" />
</ng-template>

<ng-template #meterImageTooltip>
    <img src="assets/locus-meter-example.jpg" alt="Meter Example" style="max-width: 500px; display: block;" />
</ng-template>